import { defineNuxtPlugin } from "#app";
import { useMSAuth } from "./composables/useMSAuth.js";
export default defineNuxtPlugin(async (_nuxtApp) => {
  const options = _nuxtApp.$config.public.atomNuxt;
  if (options.azureAdB2C) {
    if (import.meta.client) {
      const { initialize } = useMSAuth();
      await initialize();
    }
  }
});
